// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bt-b";
export var colorBlue = "_bt-8";
export var colorDot = "_bt-0";
export var colorDotLarge = "_bt-2";
export var colorDotSmall = "_bt-1";
export var colorGreen = "_bt-7";
export var colorGrey = "_bt-3";
export var colorOrange = "_bt-5";
export var colorPink = "_bt-a";
export var colorPurple = "_bt-9";
export var colorRed = "_bt-4";
export var colorYellow = "_bt-6";